import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { Alert, Typography } from "@platform/design-system";

interface HiddenColumnsBannerProps {
  hiddenCount: number;
}

export function HiddenColumnsBanner({
  hiddenCount,
}: HiddenColumnsBannerProps): React.ReactElement | null {
  if (hiddenCount === 0) return null;

  const columnWord = hiddenCount === 1 ? "column" : "columns";
  const theseColumnWord = hiddenCount === 1 ? "this column" : "these columns";

  return (
    <Alert
      severity="warning"
      variant="outlined"
      icon={<VisibilityOffOutlinedIcon fontSize="small" />}
    >
      <Typography variant="body-medium" color="inherit">
        The table you are currently viewing has{" "}
        <strong>
          {hiddenCount} hidden {columnWord}
        </strong>
        . To unhide {theseColumnWord}, please right click on the table header
        below to reset column display.
      </Typography>
    </Alert>
  );
}
